// extracted by mini-css-extract-plugin
module.exports = {"outer":"pageheader-module--outer--2Bneu","inner":"pageheader-module--inner--2u6L2"};